import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { Origin }           from "Utils/API";

// Types
import {
    ORIGIN, ORIGIN_LOADING,
    ORIGIN_LIST, ORIGIN_ELEM, ORIGIN_CREATE,
} from "Utils/Types";



/**
 * Fetches the Origins List
 * @param {Object=}  params
 * @param {Boolean=} withLoader
 * @returns {(dispatch: Function) => Void}
 */
export function fetchOrigins(params = {}, withLoader = true) {
    return async (dispatch) => {
        if (withLoader) {
            dispatch({ type : ORIGIN_LOADING });
        }
        Params.unset(params);
        const data = await Origin.getAll(params);
        data.sort = params;
        dispatch({ type : ORIGIN_LIST, data });
        dispatch(setSection(ORIGIN));
    };
}

/**
 * Fetches a single Origin
 * @param {Number} originID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchOrigin(originID) {
    return async (dispatch) => {
        const data = await Origin.getOne({ originID });
        dispatch({ type : ORIGIN_ELEM, data });
    };
}

/**
 * Fetches the Origin Create data
 * @returns {(dispatch: Function) => Void}
 */
export function fetchOriginCreate() {
    return async (dispatch) => {
        const data = await Origin.getCreateData();
        dispatch({ type : ORIGIN_CREATE, data });
    };
}



/**
 * Edits an Origin
 * @param {Object} data
 * @returns {() => Void}
 */
export function editOrigin(data) {
    return () => Origin.edit(data);
}

/**
 * Deletes an Origin
 * @param {Number} originID
 * @returns {() => Void}
 */
export function deleteOrigin(originID) {
    return () => Origin.delete({ originID });
}
